import React from 'react';
import {
  Navigate,
  Outlet,
  useLocation
} from 'react-router-dom';

const PrivateRoute = () => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  // No active session
  if (!token) {
    const currentUrl =
      location.pathname +
      location.search +
      location.hash;

    console.log(
      'PrivateRoute - Saving redirectAfterLogin:',
      currentUrl
    );

    // Always update with the latest URL
    localStorage.setItem(
      'redirectAfterLogin',
      currentUrl
    );

    return <Navigate to="/" replace />;
  }

  const userDetails = JSON.parse(
    localStorage.getItem('userDetails') || '{}'
  );

  // MARKET user should not access /global or /
  if (
    userDetails.role === 'MARKET' &&
    (
      location.pathname === '/global' ||
      location.pathname === '/'
    )
  ) {
    const lang = Array.isArray(userDetails.languageCode)
      ? userDetails.languageCode[0]
      : userDetails.languageCode;

    const languageCode = lang
      ? lang.split('-')[0]
      : 'EN';

    return (
      <Navigate
        to={`/dppsi/${userDetails.market}/${languageCode}/menu`}
        replace
      />
    );
  }

  // User is authenticated and can access the requested route
  return <Outlet />;
};

export default PrivateRoute;
